import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=64339962&scoped=true&"
import script from "./MegaMenu.vue?vue&type=script&lang=js&"
export * from "./MegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=64339962&prod&lang=scss&scoped=true&"
import style1 from "./MegaMenu.vue?vue&type=style&index=1&id=64339962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64339962",
  null
  
)

export default component.exports